import React from 'react';
import { Twitter, Send, MessageCircle, TrendingUp } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const footerSections = {
    Network: ['Architecture', 'Tokenomics', 'Security', 'Governance'],
    Developers: ['Documentation', 'GitHub', 'Grants', 'API Reference'],
    Resources: ['Whitepaper', 'Blog', 'Media Kit', 'Brand Guidelines'],
    Company: ['About', 'Roadmap', 'Team', 'Contact'],
  };

  const scrollToSection = (id) => {
    const sectionId = id.toLowerCase();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer-alien" data-testid="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Brand Section */}
          <div className="footer-brand">
            <img
              src="https://customer-assets.emergentagent.com/job_592594db-80a8-424b-aef8-5e7847c76b85/artifacts/4f9emqc5_Nomoex%20Logo%20White.svg"
              alt="Nomoex"
              className="footer-logo"
            />
            <p className="footer-tagline">
              The Multi-L1 Layer-2 Blockchain for Global Financial Infrastructure
            </p>
            <div className="footer-socials">
              <a href="https://x.com/nomoex_global" target="_blank" rel="noopener noreferrer" className="footer-social-link" data-testid="footer-twitter">
                <Twitter size={20} />
              </a>
              <a href="https://t.me/nomoexcommunity" target="_blank" rel="noopener noreferrer" className="footer-social-link" data-testid="footer-telegram">
                <Send size={20} />
              </a>
              <a href="https://discord.com/invite/W4R2aRY5" target="_blank" rel="noopener noreferrer" className="footer-social-link" data-testid="footer-discord">
                <MessageCircle size={20} />
              </a>
              <a href="https://coinmarketcap.com/currencies/nomoex/" target="_blank" rel="noopener noreferrer" className="footer-social-link" data-testid="footer-cmc">
                <TrendingUp size={20} />
              </a>
            </div>
          </div>

          {/* Footer Links */}
          <div className="footer-links-grid">
            {Object.entries(footerSections).map(([category, links]) => (
              <div key={category} className="footer-column">
                <h4 className="footer-column-title">{category}</h4>
                <ul className="footer-links-list">
                  {links.map((link, index) => (
                    <li key={index}>
                      <button
                        onClick={() => scrollToSection(link)}
                        className="footer-link"
                        data-testid={`footer-link-${link.toLowerCase()}`}
                      >
                        {link}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {new Date().getFullYear()} Nomoex Chain. All rights reserved.
            </p>
            <div className="footer-legal">
              <a href="#" className="legal-link" data-testid="privacy-link">Privacy Policy</a>
              <span className="legal-dot">•</span>
              <a href="#" className="legal-link" data-testid="terms-link">Terms of Service</a>
              <span className="legal-dot">•</span>
              <a href="#" className="legal-link" data-testid="cookies-link">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;